
import img1 from "@assets/images/home/getty-images-5dpagkuxf64-unsplash.jpg";
import Feature from "./feature";
import { companyFeatures } from "../../../../_mock-api's/index";

import './style.scss';

const CompanyTravels = () => {
  return (
    <section className="pb-0 pb-xl-5 mb-5 company-travels">
      <div className="container">
        <div className="row gx-0 gy-2 g-sm-2 justify-content-between align-items-top">
          <div className="col-lg-5 position-relative">
            <img
              src={img1}
              className="rounded-3 position-relative"
              alt="Company Travels"
            />
          </div>

          <div className="col-lg-6">
            <h2 className="mb-3 mb-lg-5 main-title">
              Manage and control how and where your company travels
            </h2>

            <div className="row gx-0 gy-4 g-sm-4">
              {companyFeatures.map((feature, index) => (
                <Feature
                  key={index}
                  iconClass={feature.iconClass}
                  bgClass={feature.bgClass}
                  title={feature.title}
                >
                  {feature.description}
                </Feature>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { CompanyTravels };
